//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import AButton from './components/button/button.vue'
import ApplicationFormSection from '~/components/common/section/ApplicationFormSection'

export default {
  name: 'MathsStartBlock',
  components: { AButton, ApplicationFormSection },
  mixins: [scroll],
  data() {
    return {
      isTablet: null,
      isThanksMessageActive: false,
      isErrorMessageActive: false,
    }
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    windowSizeHandler() {
      this.isTablet = window.innerWidth <= 960
    },
    showThanksMessage() {
      this.isThanksMessageActive = true
    },
    showErrorMessage() {
      this.isErrorMessageActive = true
    },
  },
}
